<div *ngIf="allowed && examId" class="popup-patientDetails" style="display: flex; flex-wrap: wrap; gap: 1em; margin-top: 1em; padding-top: 0.8em; border-top: 1px solid #13758838;">
  <div class="l-flex l-flex-c t-field t-field-pad" style="flex: 1 1 14em;">
    <label>Payer Status</label>
    <i class="t-sep"></i>
    <span class="t-validation-wrap l-fg1">
      <select class="t-select w100" [(ngModel)]="payerStatus" [ngModelOptions]="{standalone: true}" (ngModelChange)="save('payerStatus')">
        <option *ngFor="let status of statuses" [value]="status">{{labels[status]}}</option>
      </select>
    </span>
  </div>
  <div class="l-flex l-flex-c t-field t-field-pad" style="flex: 1 1 14em;">
    <label>Performer Status</label>
    <i class="t-sep"></i>
    <span class="t-validation-wrap l-fg1">
      <select class="t-select w100" [(ngModel)]="performerStatus" [ngModelOptions]="{standalone: true}" (ngModelChange)="save('performerStatus')">
        <option *ngFor="let status of statuses" [value]="status">{{labels[status]}}</option>
      </select>
    </span>
  </div>
  <p *ngIf="error" style="color: rgb(243, 63, 53); width: 100%; margin: 0;">Failed to save, please try again</p>
</div>
